import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgSquaresFour = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.375 4.375h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Zm0 7h-5.25v-5.25h5.25v5.25Zm10.5-7h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Zm0 7h-5.25v-5.25h5.25v5.25Zm-10.5 3.5h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Zm0 7h-5.25v-5.25h5.25v5.25Zm10.5-7h-5.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h5.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Zm0 7h-5.25v-5.25h5.25v5.25Z" />
  </svg>
);
export default SvgSquaresFour;
